// extracted by mini-css-extract-plugin
export default {"root":"CartLink_root__3YTiW","iconWrapper":"CartLink_iconWrapper__8uXOk","badge":"CartLink_badge__BYz6m","label":"CartLink_label__5w9iJ"};